export const customizedColumns = {
  customize_columns: "Personalizar Columnas",
  customize_columns_title: "Personalizar Columnas",
  customize_columns_description:
    "Elige qué columnas se muestran de forma predeterminada en la tabla.",
  columns_updated_successfully: "Columnas actualizadas con éxito",
  customize_columns_disabled_filtered_view:
    "Las columnas no se pueden personalizar cuando se aplica una vista filtrada",
  reset_to_default: "Restablecer valores predeterminados",
  invoice_id: "ID de factura",
  po_id: "ID de orden de compra",
  delivery_note_id: "ID de albarán",
  vendor_company_name: "Nombre de la empresa proveedora",
  customer_company_name: "Nombre de la empresa cliente",
  document_date: "Fecha del documento",
};
